<template>
  <div
    class="l-pt2 show-details-mobile gray annual"
  >
    <div
      v-for="(featuresInSection, featureSectionName) in features"
      :key="featureSectionName"
    >
      <div class="l-mxn1 l-mb2">
        <div class="mct-card__feature-category l-mb1-5 l-px1">
          {{ featureSectionName | capitalize }}
        </div>
        <div>
          <div
            class="mct-card__feature-row"
            v-for="(
              individualFeatureValue, individualFeatureName
            ) in featuresInSection"
            :key="individualFeatureName"
          >
            <div
              :class="{'bold-font': individualFeatureName === 'max-participants'}"
            >
              {{ individualFeatureValue.title }}
            </div>
            <div>
              <div
                :class="{
                  'mct-card__check--basic': subscriptionType !== 'one-time' && type === 'free'
                    || subscriptionType === 'one-time' && type === 'mini',
                  'mct-card__check--yellow': subscriptionType !== 'one-time' && type === 'essential'
                    || subscriptionType === 'one-time' && type === 'small',
                  'mct-card__check--green': subscriptionType !== 'one-time' && type === 'plus'
                    || subscriptionType === 'one-time' && type === 'medium',
                  'mct-card__check--purple': subscriptionType !== 'one-time' && type === 'pro'
                    || subscriptionType === 'one-time' && type === 'large',
                }"
              >
                <span
                  v-if="formatData(
                    individualFeatureValue.planVal &&
                      individualFeatureValue.planVal[indexByType]
                  ) === 'correctCheck'"
                >
                  <svg viewBox="0 0 20 16.1" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.1,107.161a1.533,1.533,0,0,0-1.586-1.561,1.905,1.905,0,0,0-.927.292c-4.194,2.245-10.879,9.83-10.879,9.83-.488-.412-3.464-3.145-3.464-3.145h-.024l-.024-.024h0a2.085,2.085,0,0,0-1.267-.512,1.826,1.826,0,0,0-1.829,1.829,2.194,2.194,0,0,0,.659,1.39A41.7,41.7,0,0,1,15.37,120.5a2.143,2.143,0,0,0,1.755,1.2,1.726,1.726,0,0,0,1.341-.635,4.181,4.181,0,0,0,.414-.561c1.172-1.9,5.245-8.123,10.05-11.685C29.612,108.284,30.1,107.919,30.1,107.161Z" transform="translate(-10.1 -105.6)"></path>
                  </svg>
                </span>
                <span
                  v-else-if="formatData(
                    individualFeatureValue.planVal &&
                      individualFeatureValue.planVal[indexByType]
                  ) === 'falseCheck'"
                >
                  <svg
                    class="close-icon"
                    height="15"
                    viewBox="0 0 24 24"
                    width="15"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none"></path>
                    <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path>
                  </svg>
                </span>
                <span
                  :class="{
                    'bold-font': type !== 'free' && individualFeatureName === 'max-participants'
                  }"
                  v-else
                >
                  {{ formatData(
                    individualFeatureValue.planVal &&
                      individualFeatureValue.planVal[indexByType]
                  ) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import featuresByPlan from './featuresByPlan'

export default {
  props: {
    subscriptionType: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      featuresByPlan,
    }
  },
  computed: {
    features() {
      const features = this.featuresByPlan[this.subscriptionType]
      // remove some unused features used by desktop
      delete features.updateLink
      delete features.planPrices
      delete features.plansDropdown
      return features
    },
    indexByType() {
      const indexBySubscriptionTypeSubMap = ['free', 'essential', 'plus', 'pro']
      const indexByOneTimeTypeSubMap = ['mini', 'small', 'medium', 'large']
      return this.subscriptionType === 'one-time'
        ? indexByOneTimeTypeSubMap.indexOf(this.type)
        : indexBySubscriptionTypeSubMap.indexOf(this.type)
    },
  },
  methods: {
    formatData(data) {
      if (parseInt(data, 10)) {
        return data
      }
      return data ? 'correctCheck' : 'falseCheck'
    },
  },
}
</script>

<style lang="scss" scoped>
.l-mx1 {
  margin-left: 10px;
  margin-right: 10px;
}

.l-mxn1 {
  margin-left: -10px;
  margin-right: -10px;
}

.l-my1 {
  margin-left: 10px;
  margin-right: 10px;
}

.l-mt1-5 {
  margin-top: 15px;
}

.l-mr1-5 {
  margin-right: 15px;
}

.l-mb1-5 {
  margin-bottom: 15px;
}

.l-mb2 {
  margin-bottom: 20px;
}

.l-px1 {
  padding-left: 10px;
  padding-right: 10px;
}

.l-pt2 {
  padding-top: 20px;
}

.tooltip.items-center {
  z-index: unset;
  opacity: 1;
  cursor: pointer;
  padding-left: 5px;
  display: unset;
}

.mct-card__check--basic svg {
  fill: #808080;
}

.close-icon {
  fill: rgba(0, 0, 0, 0.1) !important;
}

.mct-card__check--yellow svg {
  fill: #ffae09;
}

.mct-card__check--green svg {
  fill: #28c270;
}

.mct-card__check--purple svg {
  fill: #7669bf;
}

.mct-card__check--basic {
  color: #808080;
}

.mct-card__check--yellow {
  color: #ffae09;
}

.mct-card__check--green {
  color: #28c270;
}

.mct-card__check--purple {
  color: #7669bf;
}

.mct-card__feature-row {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 10px;
}

@media (min-width: 540px) {
  .mct-card__feature-row {
    font-size: 15px;
  }
}

.mct-card__feature-row:nth-child(even),
.mct-card__feature-row:only-child {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 100px;
}

.mct-card__feature-row svg {
  width: 20px;
}

.mct-card__feature-category {
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.75);
}

.bold-font {
  font-weight: bold;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

</style>
